var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v(" "+_vm._s(_vm.config.title)+" "),_c('b-form-checkbox-group',{attrs:{"options":_vm.selectOptions},model:{value:(_vm.valueModel),callback:function ($$v) {_vm.valueModel=$$v},expression:"valueModel"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }